// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"2a1f3068","182":"842ee142","447":"4ec2ad8d","525":"31821967","588":"861b4b11","608":"12445c30","787":"aad88529","938":"f5a93fee","940":"f69571bc","961":"85a1c305"}[chunkId] + ".chunk.js";
};